export default __webpack_public_path__ + "static/media/instagram-icon.c0113239.svg";